import {useEffect, useState} from 'react';
import {mrbgStore} from './mrbg/mrbgRedux';
import MrbgTimeLine from './mrbg/MrbgTimeLine.jsx';
import MP_timeLinePopup from '../static/css/MP_timeLinePopup.module.css';
import mrbgS2S from '../mrbgLib/mrbgS2S.js';

function TimeLinePopUp(){

	const
		[activeForms, setActiveForms] = useState(),
		[formID,setFormID] = useState(null),
		[cls, setCls]                 = useState(),
		[formSetting,setFormSetting] = useState({}),
		[requestDate,setRequestDate] = useState(),
		guideText = 'بعد از اینکه ناحیه و اولین تاریخ رو انتخاب کردی، میتونی تایم لاین رو ببینی، فعلا میتونی منو بفرستی برم اون کنار';

	function setClass(){
		cls === MP_timeLinePopup.active?
			setCls(`${MP_timeLinePopup.active} ${MP_timeLinePopup.hide}`):
			setCls(MP_timeLinePopup.active);
	}

	useEffect(()=>{
		if( activeForms?.includes('apoResFrame') ){
			setCls(`${MP_timeLinePopup.active} ${MP_timeLinePopup.hide}`)
			setFormID('apoRes')
		}
		else if( activeForms?.includes('apoResUpdFrame') ){
			setCls(`${MP_timeLinePopup.active} ${MP_timeLinePopup.hide}`)
			setFormID('apoResUpd')
		}
		else{
			setCls('')
			setFormID(null);
		}

	},[activeForms])
	useEffect(()=>{
		if( formID ){
			const unsubscribe = mrbgStore.subscribe(()=>{
				setFormSetting( mrbgStore.getState().formsSettings[formID] );
			})
			return () =>unsubscribe();
		}
	}, [formID]);
	useEffect(() => {
		if( formID )
			console.log(Object.entries(formSetting?.sundryField))
		if( formID && formSetting.STV?.areID?.length && Object.hasOwn(formSetting.sundryField,'beginDateTime') ){
			var
				MD = new FormData(),
				beginDateTime =
					formID === 'apoRes'?
						formSetting.sundryField.beginDateTime[0]:
						formSetting.sundryField.beginDateTime;

			setRequestDate( new Date(`${beginDateTime.replace(' ','T')}Z`).toLocaleString('fa-IR-u-nu-latn', {timeZone:'Asia/Tehran', year:'numeric', month:'2-digit', day:'2-digit'}).replace(',', '') );
			MD.append( 'areID'        , formSetting.STV.areID );
			MD.append( 'beginDateTime', beginDateTime );
			mrbgS2S(null, MD, 'dayInf', 'apoSes', false )
		}
	}, [formSetting]);
	useState(() => {
		const unsubscribe = mrbgStore.subscribe(() => {
			setActiveForms(mrbgStore.getState().activeForms)
		});
		return () => unsubscribe();
	}, [])

	return (
		<div id={MP_timeLinePopup.timeLinePopups} className={cls}>
			<div onClick={() => {setClass()}}>
				<i className="fa-solid fa-angle-left"></i>
			</div>
			<MrbgTimeLine {...{id:'8dayChart__TL',title:'جدول نوبت‌های رزرو شده',guideText,reqDate:requestDate}} />
		</div>
	)
}

export default TimeLinePopUp;